import { httpClient } from '../http/httpClient'
import { Customer } from '../../entities/Customer'

export interface CustomerResponse {
  customers: Customer[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
    order: string
  }
}

export interface CustormerParams {
  search?: string
  limit?: number
  skip?: number
  sort?: string
  order?: string
  sellerId?: string
  availableStatus?: 'HAS_AMOUNT' | 'UNAUTHORIZED' | 'ARCHIVED'
}

export async function customer(params?: CustormerParams | undefined) {
  const { data } = await httpClient.get<CustomerResponse>('/customer', {
    params,
  })

  return data
}
